import React from 'react'
import useApi from 'hooks/useApi'
import  DocViewer, { DocViewerRenderers }  from 'react-doc-viewer';

export default({ fileId }) => {
  const [file] = useApi(`/rest/v2/file/${fileId}`)

  const getDocument = () => {
    const fileObject = file ?? {}
    if (fileObject && fileObject?.file && !!fileObject?.cdn_url.length) {
      const fileExtension = fileObject.file.split('.').pop().toLowerCase();
      return [{
        uri: fileObject.cdn_url,
        fileType: fileExtension
      }]
    }
  }

  if (!file) {
    return null
  }

  return (
    <DocViewer
      className='w-full h-full'
      pluginRenderers={DocViewerRenderers}
      documents={getDocument()}
      config={{
        header: {
            disableHeader: true,
            disableFileName: true,
          }
        }}
    />
  )
}
